import { render, staticRenderFns } from "./page2.vue?vue&type=template&id=019849a4&scoped=true&"
import script from "./page2.vue?vue&type=script&lang=js&"
export * from "./page2.vue?vue&type=script&lang=js&"
import style0 from "./page2.vue?vue&type=style&index=0&id=019849a4&prod&lang=scss&"
import style1 from "./page2.vue?vue&type=style&index=1&id=019849a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019849a4",
  null
  
)

export default component.exports